<template>
    <v-overlay :value="!online" :opacity="0.85" z-index="500">
        <v-layout column align-center>
            <v-progress-circular indeterminate size="64" width="4" color="white"></v-progress-circular>
            <div class="mt-4 text-center connection-overlay__text">
                Потеряна связь с сервером.<br>
                Переподключаюсь{{ dots }}
            </div>
        </v-layout>
    </v-overlay>
</template>

<script>
    import {connectionState} from "../_helpers/connectivity";

    export default {
        name: "ConnectionOverlay",
        data() {
            return {
                dots: '',
                dotsTimer: null
            }
        },
        computed: {
            online() {
                return connectionState.online;
            }
        },
        watch: {
            online: {
                immediate: true,
                handler(online) {
                    if (online) {
                        this.stopDots();
                    } else {
                        this.startDots();
                    }
                }
            }
        },
        methods: {
            startDots() {
                if (this.dotsTimer) {
                    return;
                }
                let count = 0;
                this.dotsTimer = setInterval(() => {
                    count = (count + 1) % 4;
                    this.dots = '.'.repeat(count);
                }, 400);
            },
            stopDots() {
                if (this.dotsTimer) {
                    clearInterval(this.dotsTimer);
                    this.dotsTimer = null;
                }
                this.dots = '';
            }
        },
        beforeDestroy() {
            this.stopDots();
        }
    }
</script>

<style scoped>
    .connection-overlay__text {
        font-size: 1.1em;
        color: #fff;
    }
</style>
